import moment from 'moment';

import './Message.css';

export default function Message(props) {
    const { id, from, content, created_at } = props.data;
    const currentUserId = props.currentUser.id;

    return (
        <div id={ "chat-" + id } className={ from.id !== currentUserId ? "chats" : "chats active" }>
            <div className="chat-content">
                <div className="chat-profile-name">
                    <h6>
                        {from.name}
                    </h6>
                </div>
                <div className="message-content">
                    <div className={ from.id !== currentUserId ? "arrow-left" : "arrow-right" }>
                        <div></div>
                    </div>
                    {content}
                </div>
                <div
                    className="chat-time"
                    title={"Sent on " + moment(created_at).format("MMMM Do YYYY")}
                >
                    {moment(created_at).format("h:mm a").toUpperCase()}
                </div>
            </div>
        </div>
    );
}
